export default __webpack_public_path__ + "static/media/Hombre_E-Hunter.98a4d1b0.png";